import { PageContainer, YStack } from '@frontend/web-react';
import { HeaderButton, TrendingTasksContainer } from '@frontend/web/components';
import { useListExamplesQuery } from '@frontend/web/hooks';
import { router } from '@frontend/web/router';
import { createFileRoute } from '@tanstack/react-router';

const TrendingTasks = () => {
  const { data: examples, isLoading: isExamplesLoading, isSuccess: isListExamplesSuccess } = useListExamplesQuery();

  return (
    <PageContainer
      contentContainerClassName="pb-lg flex flex-1 justify-between overflow-y-scroll"
      isLoading={isExamplesLoading || !isListExamplesSuccess}
      isScrollable
      padding="none"
    >
      <YStack className="w-full items-center py-lg">
        <YStack className="max-w-screen-lg w-full px-md gap-lg">
          <HeaderButton
            accessibilityLabel="Go back to home"
            className="bg-cream-200 rounded-md"
            iconName="IconChevronLeft"
            onClick={router.history.back}
            size={18}
          />
          {examples?.length ? <TrendingTasksContainer examples={examples} layout="vertical" /> : null}
        </YStack>
      </YStack>
    </PageContainer>
  );
};

export const Route = createFileRoute('/app/trending-tasks')({
  component: TrendingTasks,
});
